import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

// Define the valid statuses
export type Status =
  | 'INDEXING'
  | 'PENDING'
  | 'STANDBY'
  | 'INDEXED'
  | 'DELETED'
  | 'DELETING'
  | 'FAILED'
  | 'FAILED_INDEX'
  | 'FAILED_DELETED'
  | 'NOT_MATCH'
  | 'NOT_IN_INDEX'
  | 'UNAVAILABLE'
  | 'MALICIOUS_FILE'
  | 'NOT_VERIFIED';

@Component({
  selector: 'app-badge-status',
  imports: [NgClass, FontAwesomeModule, NgbTooltipModule],
  template: `
    <div class="d-flex align-items-center">
      <span class="badge rounded-pill" [ngClass]="statusClassMap[status] || 'text-bg-secondary'">
        {{ statusTranslationMap[status] || status }}
        @if (status === 'INDEXING' || status === 'PENDING' || status === 'DELETING') {
          <span id="blinking-text" class="text-start"></span>
        }
      </span>
      @if (reason) {
      <span class="ms-2" style="margin-top: 2.6px;">
        <fa-icon [icon]="faCircleInfo" size="lg" i18n-ngbTooltip [ngbTooltip]="reason" 
          [tooltipClass]="status.includes('FAILED') ? 'qai-tooltip-error-info' : 'qai-tooltip-secondary'" 
          style="color: gray;">
        </fa-icon>
      </span>
      }
    </div>
  `,
  styleUrls: ['./badge-status.component.scss']
})
export class BadgeStatusComponent {
  faCircleInfo = faCircleInfo;

  @Input() status!: Status;
  @Input() reason!: string;

  failedStatuses = ['FAILED', 'FAILED_INDEX', 'FAILED_DELETED'];

  statusClassMap = {
    INDEXING: 'qai-bg-secondary',
    PENDING: 'qai-bg-secondary',
    STANDBY: 'qai-bg-deleted',
    INDEXED: 'qai-bg-success',
    DELETED: 'qai-bg-deleted',
    DELETING: 'qai-bg-secondary',
    FAILED: 'qai-bg-danger',
    FAILED_INDEX: 'qai-bg-danger',
    FAILED_DELETED: 'qai-bg-danger',
    NOT_MATCH: 'qai-bg-danger',
    NOT_IN_INDEX: 'qai-bg-danger',
    UNAVAILABLE: 'qai-bg-secondary',
    MALICIOUS_FILE: 'qai-bg-danger',
    NOT_VERIFIED: 'qai-bg-danger'
  };

  // Mappa delle traduzioni 
  statusTranslationMap: Record<Status, string> = {
    INDEXING: $localize`Indicizzazione`,
    PENDING: $localize`Indicizzazione`,
    STANDBY: $localize`Inizializzato`,
    INDEXED: $localize`Indicizzato`,
    DELETED: $localize`Eliminato`,
    DELETING: $localize`In Eliminazione`,
    FAILED: $localize`Fallito`,
    FAILED_INDEX: $localize`Indicizzazione Fallita`,
    FAILED_DELETED: $localize`Cancellazione Fallita`,
    NOT_MATCH: $localize`Non appartenente al target`,
    NOT_IN_INDEX: $localize`Non Indicizzato`,
    UNAVAILABLE: $localize`Non Disponibile`,
    MALICIOUS_FILE: $localize`File malevolo`,
    NOT_VERIFIED: $localize`Non Verificato`
  };
}